import { useEffect, useRef } from 'react';

export const useClickOutside = (ref, callback = () => {}) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleClickOutside = event => {
      const t = event.target;
      const el = t instanceof Element ? t : t?.parentElement;
      if (el?.closest('[data-click-outside-ignore]')) return;
      if (ref.current && !ref.current.contains(event.target)) {
        callbackRef.current();
      }
    };

    // Use capture phase so we receive the event before any child stopPropagation()
    // (e.g. in Accordion or other wrappers) can prevent it from reaching document.
    document.addEventListener('mousedown', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [ref]);
};
